import React from "react";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import BillOfMaterialModel from "../../../models/BillOfMaterialModel";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import ItemSearchMiniView from "../../Search/ItemMini";

interface BomItemCreateModel {
    billOfMaterialId: number
    billOfMaterialTemplateItemId?: number
    itemId: number
    itemRevisionId?: number
    quantity: number
}

interface IProps {
    show: boolean
    onHide: () => void
    bom: BillOfMaterialModel
    billOfMaterialId: number
    billOfMaterialTemplateItemId?: number
}

const AddBomItemPopup: React.FC<IProps> = ({ show, onHide, billOfMaterialId, billOfMaterialTemplateItemId, bom }) => {
    const { handleResult, handleException } = useNotifications();

    function handleItemclicked(itemRevision: ItemSearchResult) {
        const bomItem: BomItemCreateModel = {
            billOfMaterialId,
            itemId: itemRevision.itemId,
            billOfMaterialTemplateItemId: billOfMaterialTemplateItemId,
            quantity: 1
        }

        DataService
            .create<BomItemCreateModel>(`api/v1/BillOfMaterialItems`, bomItem)
            .then(response => {
                handleResult(response);
                if (response.isSuccesful === true) {
                    if (onHide)
                        onHide();
                }
            })
            .catch(e => handleException(e));
    }

    return (
        <Popup show={show} onHide={onHide} size={'xxl'} title={'Add item to BOM'} >
            <Popup.Body>
                <ItemSearchMiniView handleItemClicked={handleItemclicked} forBom={true} bom={bom} />
            </Popup.Body>
        </Popup>
    );
}
export default AddBomItemPopup;